export class CustomerAccountServiceHistoryViewModel {

    public type: string;
    public amount: number;
    public balance: number;
    public businessTransactionNumberId: number;
    public businessTransactionType: string;
    public businessTransactionDetail: string;
    public businessTransactionTypeId: number;
    public businessUnitId: number;
    public businessUnitName: string;
    public customerAccountId: number;
    public customerName: string;
    public customerNumberId: number;
    public financeDisbursementRequestId: number;
    public receiptId: number;
    public updatedBy: string;
    public updatedDate: Date;
    public requestType: string;
    public checkNumber: string;
    public period: string;

    constructor(json) {

        if (json) {

            this.amount = json.amount;
            this.balance = json.balance;
            this.businessTransactionNumberId = json.businessTransactionNumberId;
            this.businessTransactionType = json.businessTransactionTypeDisplayValue;
            this.businessTransactionTypeId = json.businessTransactionTypeId;
            this.businessUnitId = json.businessUnitId;
            this.businessUnitName = json.businessUnitName;
            this.businessTransactionDetail = json.businessTransactionDetail;
            this.customerAccountId = json.customerAccountId;
            this.customerName = json.customerName;
            this.customerNumberId = json.customerNumberId;
            this.financeDisbursementRequestId = json.financeDisbursementRequestId;
            this.receiptId = json.receiptId;
            this.updatedBy = json.updatedBy;
            this.updatedDate = json.updatedDate;
            this.requestType = json.requestType;
            this.checkNumber = json.checkNumber;
            this.period = json.period;

            if (this.receiptId) {
                this.type = 'receipt';
            } else if (this.financeDisbursementRequestId) {
                this.type = 'disbursement';
            } else {
                this.type = '';
            }
        }
    }
}
